import React from "react";

type Props = { fallback?: React.ReactNode; children: React.ReactNode };

export class ErrorBoundary extends React.Component<Props, { error: any }> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: any) {
    return { error };
  }
  componentDidCatch(error: any, info: any) {
    // Only record first error to avoid update depth explosion
    if (!this.state.error) {
      // eslint-disable-next-line react/no-set-state
      this.setState({ error, info });
    } else {
      // Subsequent identical errors: log only
      if (import.meta.env.DEV) console.warn("[ErrorBoundary] repeat error suppressed", error);
    }
  }
  render() {
    if (this.state.error) {
      return this.props.fallback ?? (
        <div className="p-3 rounded bg-red-950/70 text-red-200 text-sm">
          Something went wrong while rendering this section.
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
